/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import { SurveyScope } from '@g17eco/types/surveyCommon';

export interface ScopeStatsData {
  _id: string,
  name: string,
  scopeCount: number,
  answeredCount: number,
  verifiedCount: number,
  created: string;
  effectiveDate: string;
  initiativeName: string;
  initiativeId: string,
  scope?: SurveyScope
}

export interface ScopeStatsRow {
  name: string;
  count: number;
  scopeCount: number;
  answeredCount: number;
  verifiedCount: number;
  verifiedPc: number;
  answeredPc: number;
}


export interface MatchParams<T = Date> {
  fromDate?: T,
  toDate?: T
}

interface RequestScope {
  scopeType: string;
  code: string;
  scopeTags?: string[];
}

export interface ScopeGroupsParams extends MatchParams {
  scopeGroups: RequestScope[];
}


export interface Id {
  initiativeId: string;
  surveyId: string;
}

interface UtrvScopeTagsData {
  _id: Id;
  scope?: Record<string, string[] | undefined>
  initiativeName: string;
  initiativeCode: string;
  effectiveDate: Date;
  verifiedCount: number;
  answeredCount: number;
  count: number;
}

export interface StatsScopeTagsData {
  universalTrackerValues: UtrvScopeTagsData[];
}

export enum ReportTypes {
  Company = 'company',
  Survey = 'survey',
  Scope = 'scope',
  ScopeTag = 'scope_tag',
  Standard = 'standards',
  Questions = 'questions'
}
